module.exports = __webpack_public_path__ + "static/og-e286d989cddf10885fff3adba8de519b.png";